"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFederatedFailure = exports.isFederatedSuccess = exports.isFederated = exports.exchangeCodeForTokensFailure = exports.exchangeCodeForTokensSuccess = exports.exchangeCodeForTokensRequest = exports.logout = exports.setPasswordAction = exports.setEmailAction = exports.loginSuccessAction = exports.loginFailureAction = exports.loginRequestAction = exports.validateLoginFailure = void 0;
const ActionTypes = require("../../actionTypes/auth/login");
const validateLoginFailure = (errors) => ({
    type: ActionTypes.VALIDATE_LOGIN_FAILURE,
    payload: errors
});
exports.validateLoginFailure = validateLoginFailure;
const loginRequestAction = (email, password) => {
    return {
        type: ActionTypes.LOGIN_REQUEST,
        payload: {
            email,
            password
        }
    };
};
exports.loginRequestAction = loginRequestAction;
const loginFailureAction = (errorMessage) => {
    return {
        type: ActionTypes.LOGIN_FAILURE,
        payload: errorMessage
    };
};
exports.loginFailureAction = loginFailureAction;
const loginSuccessAction = (token) => {
    return {
        type: ActionTypes.LOGIN_SUCCESS,
        payload: token
    };
};
exports.loginSuccessAction = loginSuccessAction;
const setEmailAction = (email) => ({
    type: ActionTypes.SET_EMAIL,
    payload: email
});
exports.setEmailAction = setEmailAction;
const setPasswordAction = (password) => ({
    type: ActionTypes.SET_PASSWORD,
    payload: password
});
exports.setPasswordAction = setPasswordAction;
const logout = () => {
    return {
        type: ActionTypes.LOGOUT
    };
};
exports.logout = logout;
function exchangeCodeForTokensRequest(params) {
    return {
        type: ActionTypes.EXCHANGE_CODE_FOR_TOKENS_REQUEST,
        payload: params
    };
}
exports.exchangeCodeForTokensRequest = exchangeCodeForTokensRequest;
function exchangeCodeForTokensSuccess(token) {
    return {
        type: ActionTypes.EXCHANGE_CODE_FOR_TOKENS_SUCCESS,
        payload: token
    };
}
exports.exchangeCodeForTokensSuccess = exchangeCodeForTokensSuccess;
function exchangeCodeForTokensFailure(payload) {
    return {
        type: ActionTypes.EXCHANGE_CODE_FOR_TOKENS_FAILURE,
        payload
    };
}
exports.exchangeCodeForTokensFailure = exchangeCodeForTokensFailure;
function isFederated(email) {
    return {
        type: ActionTypes.IS_FEDERATED,
        payload: email
    };
}
exports.isFederated = isFederated;
function isFederatedSuccess(data) {
    return {
        type: ActionTypes.IS_FEDERATED_SUCCESS,
        payload: data
    };
}
exports.isFederatedSuccess = isFederatedSuccess;
function isFederatedFailure(payload) {
    return {
        type: ActionTypes.IS_FEDERATED_FAILURE,
        payload
    };
}
exports.isFederatedFailure = isFederatedFailure;
//# sourceMappingURL=login.js.map